import { useEffect } from 'react'
import { useSelector } from 'react-redux'

const ref = document.createElement("div");

document.body.append(ref);

export function ReCaptchaVisibility({ children }) {
  const isAuthenticate = useSelector((state) => !!state.Login.data)

  useEffect(() => {
    if (!isAuthenticate) ref.style.display = 'block'
    else ref.style.display = 'none'
  }, [isAuthenticate])

  return <>{children}</>
}

ReCaptchaVisibility.ref = ref
